/*
 * @Author: jingyu.yang 
 * @Date: 2021-12-17 09:53:10 
 * @Last Modified by:   jingyu.yang 
 * @Last Modified time: 2021-12-17 09:53:10 
 */
import {get, post, getJson, deleteMethod } from '.'
/*发起抽奖 */
export const startLuckDraw = (data) => {
  return post(`${config.cpp}handler/v2/raffle`, data);
}

/* 获取抽奖人数 */
export const getLuckCount = (data) => {
  return getJson(`${config.cpp}handler/v2/raffle/user/count`, data);
}

/* 获取中奖记录 */
export const getRaffleInfo = (data) => {
  return post(`${config.cpp}handler/raffle/conf/list`, data);
}

/**
 * 查询中奖预设人员信息
 */
 export const getLuckUsers = (data) => {
  return getJson(`${config.cpp}handler/v2/raffle/preset/users`, data);
}
/**
 * 下载导入模板
 * @param {*} params 
 * @returns 
 */
export const importUser = () => {
  return get(`${config.cpp}handler/v2/raffle/download/template`,"",{responseType: "arraybuffer"});
}
/**
 * 导入抽奖人名单
 * @returns 
 */
export const uploadUser = (file) => {
  return post(`${config.cpp}handler/v2/raffle/import`,file);
}


// 新加的不知道用哪个获取中奖历史
export const getWinnerHistory = (params) => {
  return getJson(`${config.cpp}handler/v1/raffle/conf/record`, params);
}

/*根据抽奖id获取中奖信息 */
export const getRaffleWinUser = (params) => {
  return getJson(`${config.cpp}handler/v1/raffle/winner/list/raffleId`, params);
}
/*下发中奖结果 */
export const comfireRaffleResult = (data) => {
  return post(`${config.cpp}handler/v2/raffle/state`, data);
}

/** 查询进行中的口令抽奖 */
export const getRunningPasswordRaffle = () => {
  return getJson(`${config.cpp}handler/v2/raffle/password/running`);
}

/*口令抽奖,取消开奖 */
export const cancelPasswordRaffle = (data) => {
  return post(`${config.cpp}handler/v2/raffle/password/cancel`, data);
}

/*口令抽奖,手动开奖 */
export const drawPasswordRaffle = (data) => {
  return post(`${config.cpp}handler/v2/raffle/password/draw`, data);
}

/** 口令抽奖,提交口令的观众列表 */
export const getPasswordRaffleSubmitList = (raffleId, params) => {
  return getJson(`${config.cpp}handler/v2/raffle/password/submit/list/${raffleId}`, params);
}

/** 口令抽奖,提交口令的观众人数 */
export const getPasswordRaffleSubmitCount = (raffleId) => {
  return getJson(`${config.cpp}handler/v2/raffle/password/submit/count/${raffleId}`);
}

/**
 * 获取组合轮次
 */
 export const getRounds = (data) => {
  return getJson(`${config.cpp}handler/v2/raffle/combination/rounds`, data);
}
/** 新增答题 */
export const addAnswerSheetApi = (data) => {
  return post(`${config.cpp}handler/v1/answerSheet/add`, data);
};
/** 编辑答题 */
export const updateAnswerSheetApi = (data) => {
  return post(`${config.cpp}handler/v1/answerSheet/update`, data);
};

/** 获取答题卡列表 */
export const getAnswerSheetList = (params) => {
  return getJson(`${config.cpp}handler/v1/answerSheet/webcast/list`, params);
};

/** 获取答题卡详情 */
export const getwebcastAnswerSheetInfo = (id) => {
  return getJson(`${config.cpp}handler/v1/answerSheet/webcast/${id}`);
};

/** 获取答题统计信息 */
export const getAnswerSheetIdApi = (id) => {
  return getJson(`${config.cpp}handler/v1/answerSheet/question/base_result/${id}`);
};

/** 发布问卷 */
export const releaseAnswerSheet = (data) => {
  return post(`${config.cpp}handler/v1/answerSheet/publish`, data);
};

/** 结束发布答题 */
export const finishAnswerApi = (data) => {
  return post(`${config.cpp}handler/v1/answerSheet/stopAnswer/${data.id}`, data);
};
/** 删除问答题 */
export const deletAnswerSheetApi = (id) => {
  return deleteMethod(`${config.cpp}handler/v1/answerSheet/question/${id}`);
};
